var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from "lodash/get";
import { getUniqueCartItemId } from "../helpers";
import { currency } from "../../helpers/";
var CartItem = /** @class */ (function () {
    function CartItem(priceModel, timespan, props) {
        var _a;
        this.priceModel = priceModel;
        this.timespan = timespan;
        this.props = props;
        this.isBookedOut = false;
        this.isRoot = false;
        this.isExtraPrice = false;
        this.isExtraArticle = false;
        this.defaultIndices = [];
        this.isSchedulingTimespan = (_a = this.timespan) === null || _a === void 0 ? void 0 : _a.isSchedulingTimespan;
        this.booking = this._booking;
        this.position = this._position;
    }
    Object.defineProperty(CartItem.prototype, "index", {
        get: function () {
            return this.props.index;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "timespanId", {
        get: function () {
            return (this.timespan ? String(this.timespan.id) : null);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "priceId", {
        get: function () {
            var _a;
            return String(((_a = this.priceModel) === null || _a === void 0 ? void 0 : _a.id) || "");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "parentPriceId", {
        get: function () {
            var _a, _b;
            return ((_a = this.priceModel) === null || _a === void 0 ? void 0 : _a.parent_price_id)
                ? String((_b = this.priceModel) === null || _b === void 0 ? void 0 : _b.parent_price_id)
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "uniqueParentId", {
        get: function () {
            return this.props.grandParentId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "bookingSlot", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "onDate", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "dirtyParentItem", {
        get: function () {
            var parentPriceId = Number(this.props.grandParentId) === Number(this.parentPriceId) ? null : this.props.grandParentId;
            return get(this.props.dirtyValues, getUniqueCartItemId(this.parentPriceId, parentPriceId, this.timespanId, this.props.bookingSlot));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "dirtyCartItem", {
        get: function () {
            var key = getUniqueCartItemId(this.priceId, this.parentPriceId, this.timespanId, this.props.bookingSlot);
            return get(this.props.dirtyValues, key);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "quantity", {
        get: function () {
            return String(0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "personalDataIndex", {
        get: function () {
            var _a;
            return (((_a = this.booking) === null || _a === void 0 ? void 0 : _a.personal_data_index) || []);
        },
        set: function (personalDataIndex) {
            if (!this.booking) {
                return;
            }
            this.booking.personal_data_index = personalDataIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "_booking", {
        get: function () {
            return {
                course_timespan_id: this.timespanId,
                quantity: this.quantity,
                personal_data_index: this.personalDataIndex
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "_position", {
        get: function () {
            return {
                price_id: this.priceId,
                quantity: this.quantity,
                parent_price_id: this.parentPriceId
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "participantFormGroupId", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.timespan) === null || _a === void 0 ? void 0 : _a.participantFormItem().formGroup()) === null || _b === void 0 ? void 0 : _b.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "participantCount", {
        get: function () {
            return Number(this.quantity);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CartItem.prototype, "toWaitList", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.props.rootCartItem) === null || _a === void 0 ? void 0 : _a.toWaitList) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    CartItem.prototype.getItem = function () {
        return {
            onDate: this.onDate,
            bookingSlot: this.bookingSlot,
            booking: this.booking,
            position: this.position
        };
    };
    CartItem.prototype.getAsRowItem = function () {
        var _this = this;
        var _a, _b, _c;
        var id = this.priceId || this.timespanId;
        var quantity = Number(this.quantity);
        if (!id)
            return null;
        if (quantity <= 0) {
            return null;
        }
        if (!this.timespan) {
            return [];
        }
        var selectedSlot = this.bookingSlot;
        var availableTimespans = this.timespan.getAvailablePrices({
            quantity: this.quantity,
            maxQuantity: this.timespan.deriveQuantityLeft({ selectedSlot: selectedSlot })
        });
        var isBookingWaitlist = Number(this.quantity) > this.timespan.max_quantity_left_for_real;
        if (availableTimespans.size === 0) {
            return [{
                    id: id,
                    quantity: quantity,
                    sumTotal: 0,
                    sumTotalFormatted: currency(0).format(),
                    className: isBookingWaitlist ? "ws-price-summary-waitlist" : "",
                    title: ((_a = this.timespan) === null || _a === void 0 ? void 0 : _a.getAsTitle([], { placement: "price_summary", titleKey: "timespan_format" }, { isBookingWaitlist: isBookingWaitlist, selectedSlot: selectedSlot })) || "",
                }];
        }
        if (!this.priceId) {
            return [];
        }
        var title = !this.isRoot ? this.priceModel.getPriceAsTitle(false) : ((_b = this.timespan) === null || _b === void 0 ? void 0 : _b.getAsTitle([], { placement: "price_summary", titleKey: "timespan_format" }, {
            priceId: ((_c = this.priceModel) === null || _c === void 0 ? void 0 : _c.id) === Number(this.priceId) ? this.priceId : null,
            showSinglPriceTitle: true,
            isBookingWaitlist: isBookingWaitlist,
            selectedSlot: selectedSlot
        }));
        var prices = [__assign(__assign({}, this.priceModel.getAsRowItem(quantity)), { isExtraPrice: !this.isRoot, className: isBookingWaitlist ? "ws-price-summary-waitlist" : "", title: title })];
        return prices.concat(this.priceModel.getAllSubPrices().map(function (m, i) {
            return __assign(__assign({}, m.getAsRowItem(quantity)), { isExtraPrice: !_this.isRoot, isSubPrice: true, className: "" });
        }));
    };
    CartItem.prototype.toResponseObject = function (sanitizedState) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var quantity = this.quantity;
        var item = this.getItem();
        if (this.toWaitList) {
            return [{
                    booking: __assign(__assign({}, item.booking), { personal_data_index: undefined }),
                    position: this.priceId ? this.position : undefined
                }];
        }
        if (!((_a = this.timespan) === null || _a === void 0 ? void 0 : _a.shouldCollectParticipantInformation)) {
            return [{
                    booking: sanitizedState.billRecipientIndex ? __assign(__assign({}, this.booking), { personal_data_index: sanitizedState.billRecipientIndex }) : undefined,
                    position: this.priceId ? this.position : undefined
                }];
        }
        if ((_b = this.timespan) === null || _b === void 0 ? void 0 : _b.shouldTakeOnlyOneParticipant) {
            return [{
                    booking: ((_d = (_c = item.booking) === null || _c === void 0 ? void 0 : _c.personal_data_index) === null || _d === void 0 ? void 0 : _d[0]) ? __assign(__assign({}, this.booking), { personal_data_index: (_f = (_e = item.booking) === null || _e === void 0 ? void 0 : _e.personal_data_index) === null || _f === void 0 ? void 0 : _f[0] }) : undefined,
                    position: this.priceId ? this.position : undefined
                }];
        }
        return new Array(+quantity).fill(null).map(function (x, index) {
            var _a, _b, _c, _d;
            return {
                booking: ((_b = (_a = item.booking) === null || _a === void 0 ? void 0 : _a.personal_data_index) === null || _b === void 0 ? void 0 : _b[index])
                    ? __assign(__assign({}, item.booking), { quantity: String(1), personal_data_index: (_d = (_c = item.booking) === null || _c === void 0 ? void 0 : _c.personal_data_index) === null || _d === void 0 ? void 0 : _d[index] }) : undefined,
                position: _this.priceId
                    ? __assign(__assign({}, item.position), { quantity: String(1) }) : undefined
            };
        });
    };
    return CartItem;
}());
export { CartItem };
